import config from 'config';
import { authHeader } from '@mobile/services/user';
import axios from '@mobile/util/axios';
import quietAxios from '@mobile/util/quietAxios';

async function get(inspectionId) {
    const response = await axios.get(
    	`${config.apiUrl}/${config.apiVersion}/notifications/${inspectionId}`,
    	{ headers: authHeader() },
    );

    if (response && response.status == 200) {
        return response.data;
    }
}

async function getAll(url, filters = {}) {
    if (!url) {
        url = `${config.apiUrl}/${config.apiVersion}/notifications`;
    }

    const filtersToSend = JSON.parse(JSON.stringify(filters));

    const response = await axios.get(
    	url,
    	{
            headers: authHeader(),
            params: filtersToSend,
        },
    );

    if (response && response.status == 200) {
        return response.data;
    }
}

async function getUnreadCount() {
    const url = `${config.apiUrl}/${config.apiVersion}/notifications/unread-count`;
    const response = await quietAxios.get(
        url,
        { headers: authHeader() },
    );

    if (response && response.status == 200) {
        return response.data;
    }
}

async function changeStatusToRead(notificationId) {
    const response = await axios.put(
        `${config.apiUrl}/${config.apiVersion}/notifications/read/${notificationId}`,
        '',
        { headers: authHeader() },
    );

    if (response && response.status == 200) {
        return response.data;
    }
}

export default {
    get,
    getAll,
    getUnreadCount,
    changeStatusToRead,
};
